import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { PromoBanner } from './PromoBanner';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen bg-cream font-body selection:bg-brand-gold selection:text-near-black flex flex-col" data-id="element-227">
      <div className="sticky top-0 z-50 flex flex-col" data-id="element-228">
        <PromoBanner data-id="element-229" />
        <Navbar data-id="element-230" />
      </div>
      <main className="flex-grow" data-id="element-231">
        <Outlet data-id="element-232" />
      </main>
      <Footer data-id="element-233" />
    </div>;
}